export { default } from "./FormattedNumber";